const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const request = async (endpoint, options = {}) => {
  console.log("API_BASE_URLAPI_BASE_URL", API_BASE_URL);
  const url = `${API_BASE_URL}${endpoint}`;

  const token = localStorage.getItem('token');
  
  const config = {
    mode: 'cors',
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };

  try {
    const response = await fetch(url, config);

    // if (!response.ok) {
    //   throw new Error(`HTTP error! status: ${response.status}`);
    // }

    return await response.json();
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};

export const api = {
  get: (endpoint, options = {}) =>
    request(endpoint, { method: "GET", ...options }),
  post: (endpoint, data, options = {}) =>
    request(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      ...options,
    }),
  put: (endpoint, data, options = {}) =>
    request(endpoint, {
      method: "PUT",
      body: JSON.stringify(data),
      ...options,
    }),
  delete: (endpoint, options = {}) =>
    request(endpoint, { method: "DELETE", ...options }),
};

export default api;
